import Vue from 'vue'

export default Vue.component('bid-dialog', {
    props: ['bid', 'minbid', 'currency', 'monetization'],

    data() {
        return {
            isAlert: false
        }
    },

    methods: {
        isDutch() { return this.monetization.mode === 'dutch' },
        isJapan() { return this.monetization.mode === 'japanese' },
        toPrice(str) { return str ? parseFloat(str.toString().replace(/ /g, '')) : '' },
        cancel() {
            this.$emit('cancel')
        },

        async submit() {
            this.$emit('confirm')
        },

        beforeOpen() {
            if (this.isDutch() || this.isJapan()) {
                return
            }
    
            const bid = this.toPrice(this.bid)
            const minbid = this.toPrice(this.minbid)
            const percentageBidDiff = Math.abs(((minbid - bid) / minbid) * 100);
            this.isAlert = percentageBidDiff > 10
        }
    }
});
